
import React from 'react'

export default function Monitorroport() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                    <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Monitoring and Reporting</h4><br></br>
                    </div>

                    <div> 
                        <p>
                        The status of invasive species will be reviewed on a regular basis by staff based on feedback from community,contractors and staff observations.The Plan will be reviewed every ten years to revise the vision and objectives, accommodate new actions and revise existing actions. The community will be invited to have input into the review. 
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
